module.exports = __webpack_public_path__ + "img/car.32f22e82.svg";